import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { MessageTextarea as MessageTextareaNative } from './MessageTextarea.shared'

export const MessageTextarea = withBrowserTextareaHeight(MessageTextareaNative)
